import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import QuizCategories from './components/QuizCategories';
import QuizInterface from './components/Quiz/QuizInterface';
import QuizSession from './components/Quiz/QuizSession';
import QuizResults from './components/Quiz/QuizResults';
import QuizHistory from './components/Quiz/QuizHistory';
import SignIn from './components/Auth/SignIn';
import SignUp from './components/Auth/SignUp';
import Dashboard from './components/Dashboard';
import './App.css';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/signin" />;
  }

  // Clone children and pass currentUser as prop
  return React.Children.map(children, child => {
    return React.cloneElement(child, { user: currentUser });
  });
};

// Page transition wrapper
const PageTransition = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      mainContent.classList.add('page-enter');
      mainContent.classList.remove('page-exit', 'page-exit-active');

      requestAnimationFrame(() => {
        mainContent.classList.add('page-enter-active');
        mainContent.classList.remove('page-enter');
      });
    }
  }, [location]);

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Navbar />
          <PageTransition>
            <div className="main-content">
              <Routes>
                <Route path="/" element={
                  <>
                    <Hero />
                    <Features />
                    <QuizCategories />
                  </>
                } />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/signup" element={<SignUp />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/quiz" 
                  element={
                    <ProtectedRoute>
                      <QuizInterface />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/quiz/session" 
                  element={
                    <ProtectedRoute>
                      <QuizSession />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/quiz/results" 
                  element={
                    <ProtectedRoute>
                      <QuizResults />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/quiz/history" 
                  element={
                    <ProtectedRoute>
                      <QuizHistory />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </div>
          </PageTransition>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 